export class CommError extends Error {
    static code;

    constructor( message, code ) {
        super( message );
        this.code = code;
    }
}
